import { useMemo } from 'react';
import { usePlugins } from '@/hooks/config/usePlugins';
import { getBuiltInResourcePreview } from '@/lib/resource-previews';
import type { ResolvedResourcePreview } from '@/lib/plugin-registry';

/**
 * Returns the resolved resource-preview registration for `kind`, consulting
 * both the host's built-in registry and the live plugin manifests. Returns
 * `undefined` when no registration is found.
 */
export function useResourcePreviewRegistration(kind: string): ResolvedResourcePreview | undefined {
  const { resourcePreviews } = usePlugins();
  return useMemo(() => {
    const fromPlugin = resourcePreviews.get(kind);
    if (fromPlugin) return fromPlugin;
    return getBuiltInResourcePreview(kind);
  }, [kind, resourcePreviews]);
}
